import defaultSettings from '@/settings'

const title = defaultSettings.title || '知明慧学 · 后台管理'

// 与教师端一致：标签页始终显示品牌名，不拼接页面名
export default function getPageTitle() {
  return title
}
